<template>
  <div class="odd:bg-gray-100 border border-gray-200 rounded px-4 flex-1 text-sm">
    <div class="flex -mx-4 justify-between items-center">
      <div class="flex-1 p-4">
        <div class="flex flex-col lg:flex-row items-start lg:items-center -mx-4">
          <div class="w-32 px-4">
            <h5 class="text-sm">
              {{ movement.movementDate }}
            </h5>
          </div>

          <div class="flex-1 px-4 mt-4 lg:mt-0 uppercase">
            <template v-if="document">
              {{ document.type }}
            </template>
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0 text-right">
            {{ movement.amount.toFixed(2) }} &euro;
          </div>

          <div class="w-32 px-4 mt-4 lg:mt-0 text-right">
            {{ movement.balance.toFixed(2) }} &euro;
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  props: {
    movement: { type: Object, required: true },
  },

  computed: {
    ...mapState('entities', {
      document({ documents }) {
        if (!this.movement.documentUuid) return null;

        return documents.byId[this.movement.documentUuid] || null;
      },
    }),
  },
};
</script>
